import { useEffect, useState } from "react";
import { fetchStatus, readCachedStatus } from "./flowGuards";

export { MEMBER_ONLY_NAV_PATHS, PUBLIC_NAV_LINKS, visibleAppNavItems } from "./membershipNavItems";

// Dashboard, Chat, and Money show for active members only when their flags are on.
export function useMembershipNav(enabled = true) {
  const [membershipActive, setMembershipActive] = useState(() =>
    Boolean(enabled && readCachedStatus()?.membershipActive)
  );
  useEffect(() => {
    if (!enabled) {
      setMembershipActive(false);
      return undefined;
    }
    let cancelled = false;
    fetchStatus({ useCache: true, timeoutMs: 8000, retries: 1 })
      .then((status) => {
        if (!cancelled) setMembershipActive(Boolean(status?.membershipActive));
      })
      .catch(() => {
        if (!cancelled) setMembershipActive(Boolean(readCachedStatus()?.membershipActive));
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return membershipActive;
}
